import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('tree-helper', {
  template: require('./template.html'),
  name: 'tree-helper',
  computed: {
    ...mapGetters(['getContentBlocks']),
  },
  data() {
    return {
      vuexToy: false,
    };
  },
  methods: {
    pauseApp() {
      debugger; // eslint-disable-line
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/blocks-container/_tree-helper/index.js